module.exports = __webpack_public_path__ + "static/media/4.c86164e1.jpg";